import blue from './blue.png';
import orange from './darkorange.png';
import green from './lime.png';
import red from './maroon.png';
import ninja from './ninja.png';
import brown from './orangered.png';
import purple from './purple.png';
import white from './white.png';
import yellow from './yellow.png';

const ninjas = {
  ninja,
  white,
  yellow,
  orange,
  green,
  blue,
  purple,
  brown,
  red
};

export default ninjas;
